import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import ReactTooltip from 'react-tooltip';
import ApplicationDetail from "./ApplicationDetail";
import { _ButtonWrapper, FooterActionsStyled, MultipleNotesTableStyled, NotePreview, TextAreaWrapperStyled, DownloadCsvWrapper } from "./style";
import { _NoteContainer, _NoteMessage, _NoteTitleContainer } from "../../Notes/styles";
import AsyncButton from "../../core/button/AsyncButton";
import Checkbox from "../../core/input/Checkbox";
import CsvDownload from "../../CsvDownload";
import { getApplicationStatusMessage } from "../../../util/common";
import { useEventTracker, UserContext } from '@applyboard/ui-utils';
import { useInitialProps } from "../../../hooks/useInitialProps";
import RawHtml from "../../RawHtml";
import { useId } from '@applyboard/ui-components';
import { Markdown } from '@applyboard/crystal-ui';
var CSV_COLUMNS = [{
  name: 'App Id',
  selector: 'id'
}, {
  name: 'Student',
  selector: 'student'
}, {
  name: 'School',
  selector: 'school'
}, {
  name: 'Program',
  selector: 'program'
}, {
  name: 'Status',
  selector: 'status'
}, {
  name: 'Posted By',
  selector: 'postedBy'
}, {
  name: 'Timestamp',
  selector: 'createdAt'
}, {
  name: 'Sent Status',
  selector: 'sentStatus'
}];
var MultipleNotesView = function MultipleNotesView(_ref) {
  var _initialApplication$m, _content$body$text;
  var application_id_input = _ref.application_id_input,
    application_ids = _ref.application_ids,
    applicationIsProcessing = _ref.applicationIsProcessing,
    applications_map = _ref.applications_map,
    content = _ref.content,
    handleAddIds = _ref.handleAddIds,
    handlePostNoteTemplates = _ref.handlePostNoteTemplates,
    handleRemoveApplicationId = _ref.handleRemoveApplicationId,
    onChangeApplicationIds = _ref.onChangeApplicationIds,
    template_id = _ref.template_id,
    current_application = _ref.current_application,
    current_application_id = _ref.current_application_id,
    sendNoteToAllApplications = _ref.sendNoteToAllApplications,
    onToggleSendNoteToAllApplications = _ref.onToggleSendNoteToAllApplications,
    selectedLegacyApplicationIdsForBatchSend = _ref.selectedLegacyApplicationIdsForBatchSend,
    onToggleSendNoteToApplication = _ref.onToggleSendNoteToApplication,
    dataForCSV = _ref.dataForCSV,
    downloadCsvHandler = _ref.downloadCsvHandler,
    downloadCsv = _ref.downloadCsv,
    isAdminTab = _ref.isAdminTab,
    isMarkdownRendererEnabled = _ref.isMarkdownRendererEnabled;
  var _useInitialProps = useInitialProps(),
    initialApplication = _useInitialProps.application;
  var currentUser = useContext(UserContext);
  var _useEventTracker = useEventTracker({
      data: {
        applications: application_ids,
        templateId: template_id,
        userRole: currentUser === null || currentUser === void 0 ? void 0 : currentUser.role,
        applicationStatus: getApplicationStatusMessage(current_application),
        applicationStage: (initialApplication === null || initialApplication === void 0 ? void 0 : (_initialApplication$m = initialApplication.meta) === null || _initialApplication$m === void 0 ? void 0 : _initialApplication$m.current_stage.name) || (initialApplication === null || initialApplication === void 0 ? void 0 : initialApplication.current_stage.name) || (initialApplication === null || initialApplication === void 0 ? void 0 : initialApplication.current_stage),
        visibility: content.visibility,
        sentToRp: content.sendingToRp
      }
    }),
    trackEvent = _useEventTracker.trackEvent;
  var textareaLabelId = useId();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", null, "Batch send ", content.type), content.type == 'template' ? /*#__PURE__*/React.createElement("div", null, "Selected template: ", /*#__PURE__*/React.createElement("strong", null, content.body.templateTitle)) : null, /*#__PURE__*/React.createElement(NotePreview, null, /*#__PURE__*/React.createElement(_NoteContainer, null, /*#__PURE__*/React.createElement(_NoteTitleContainer, {
    isInternal: true
  }, /*#__PURE__*/React.createElement("div", null, content.body.title), /*#__PURE__*/React.createElement("span", null, "\xA0")), /*#__PURE__*/React.createElement(_NoteMessage, null, content.type === 'template' && isMarkdownRendererEnabled || content.type === 'note' && content.body.contentEncoding === 'markdown' ? /*#__PURE__*/React.createElement(Markdown, {
    markdown: (_content$body$text = content.body.text) !== null && _content$body$text !== void 0 ? _content$body$text : '',
    headingSettings: {
      baseLevel: 3,
      styles: {
        h1: {
          variant: 'bodyM',
          contrast: 'mid',
          bold: true
        }
      }
    }
  }) : /*#__PURE__*/React.createElement(RawHtml, {
    html: content.body.text
  })))), /*#__PURE__*/React.createElement(TextAreaWrapperStyled, null, /*#__PURE__*/React.createElement("label", {
    form: "application-id-input",
    id: textareaLabelId
  }, "Preview Application IDs:"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("textarea", {
    id: "application-id-input",
    name: "application_id_input",
    "aria-labelledby": textareaLabelId,
    value: application_id_input,
    onChange: function onChange(e) {
      return onChangeApplicationIds(e.target.value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "button-wrapper"
  }, /*#__PURE__*/React.createElement(_ButtonWrapper, null, /*#__PURE__*/React.createElement(AsyncButton, {
    onClick: handleAddIds
  }, "Preview")))), /*#__PURE__*/React.createElement(MultipleNotesTableStyled, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "#"), /*#__PURE__*/React.createElement("th", null, "Student"), /*#__PURE__*/React.createElement("th", null, "School"), /*#__PURE__*/React.createElement("th", null, "Program"), /*#__PURE__*/React.createElement("th", null, "Status"), /*#__PURE__*/React.createElement("th", null, "Posted by"), /*#__PURE__*/React.createElement("th", null, /*#__PURE__*/React.createElement(Checkbox, {
    inputValue: sendNoteToAllApplications,
    onChange: onToggleSendNoteToAllApplications,
    disabled: Object.keys(applications_map).length == 0,
    name: "send-note-to-all-applications-check-box"
  })))), /*#__PURE__*/React.createElement("tbody", null, application_ids.map(function (application_id) {
    return /*#__PURE__*/React.createElement(ApplicationDetail, {
      application_id: application_id,
      applications_map: applications_map,
      current_application_id: current_application_id,
      current_application: current_application,
      key: "multiple-note-application-id-".concat(application_id),
      onRemove: handleRemoveApplicationId,
      template_id: template_id,
      sendNoteToApplication: selectedLegacyApplicationIdsForBatchSend.has(application_id),
      onToggleSendNoteToApplication: onToggleSendNoteToApplication
    });
  }))), /*#__PURE__*/React.createElement(FooterActionsStyled, null, /*#__PURE__*/React.createElement(DownloadCsvWrapper, null, /*#__PURE__*/React.createElement("span", null, "".concat(selectedLegacyApplicationIdsForBatchSend.size, "/").concat(application_ids.length, " Applications Selected")), /*#__PURE__*/React.createElement(Checkbox, {
    className: "download-csv",
    inputValue: downloadCsv,
    name: "download-csv",
    onChange: downloadCsvHandler
  }), /*#__PURE__*/React.createElement("span", null, "Download CSV")), /*#__PURE__*/React.createElement(_ButtonWrapper, null, downloadCsv && dataForCSV.length ? /*#__PURE__*/React.createElement(CsvDownload, {
    columns: CSV_COLUMNS,
    data: dataForCSV
  }, /*#__PURE__*/React.createElement(AsyncButton, {
    disabled: applicationIsProcessing,
    onClick: function onClick() {
      trackEvent({
        event: "Single Application - ".concat(isAdminTab ? 'Admin Comments' : 'Notes', " - Clicked Send to Selected")
      });
      handlePostNoteTemplates();
    }
  }, "Send to Selected")) : /*#__PURE__*/React.createElement(AsyncButton, {
    disabled: applicationIsProcessing,
    onClick: function onClick() {
      trackEvent({
        event: "Single Application - ".concat(isAdminTab ? 'Admin Comments' : 'Notes', " - Clicked Send to Selected")
      });
      handlePostNoteTemplates();
    }
  }, "Send to Selected"))), /*#__PURE__*/React.createElement(ReactTooltip, {
    id: "batch-note-tooltip"
  }));
};
export default MultipleNotesView;